import React from 'react'
import Agent from './index'
import useWindowSize from '../../hooks/useWindowSize'
import { useMediaQuery } from 'react-responsive'
import { RESPONSIVE } from '../../lib/constants'
import { isAmwellTheme } from '../../lib/util'

const AgentWrapper = props => {
  const size = useWindowSize()
  const { pathname } = new URL(window.location)

  const isSmallWindow = useMediaQuery({
    query: `(max-width: ${RESPONSIVE.AGENT_SMALL_WIDTH})`
  })

  const isCrampedWindow = useMediaQuery({
    query: `(max-width: ${RESPONSIVE.AGENT_CRAMPED_WIDTH})`
  })

  const isCrampedListPanelWindow = isCrampedWindow && !pathname.includes('/home') && !pathname.includes('/note')

  const isSmallListPanelWindow = isSmallWindow && !pathname.includes('/home') && !pathname.includes('/note')

  const isSmallNoteWindow = (
    isCrampedWindow && pathname.includes('/note')
  )

  return (
    <Agent
      vw={isAmwellTheme() ? 907.7 : size?.width || window.innerWidth}
      vh={isAmwellTheme() ? 907.7 : size?.height || window.innerHeight}
      location={props.location}
      history={props.history}
      isSmallNoteWindow={isSmallNoteWindow}
      isSmallListPanelWindow={isSmallListPanelWindow}
      isCrampedListPanelWindow={isCrampedListPanelWindow}
    />
  )
}

export default AgentWrapper
